
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  AI,
  Answer,
  AIGroup,
  Candidate,
  CandidateResult,
  ReportShowConfigV5Item
} from "@/lib/model/exam/result";

@Component({})
export default class Comp0 extends Vue {
  @Prop({ default: () => new Candidate() }) candidate!: Candidate;
  @Prop({ default: () => new CandidateResult() }) all!: CandidateResult;
  @Prop({ default: "" }) connectCode!: string;
  @Prop({ default: () => new ReportShowConfigV5Item() })
  option!: ReportShowConfigV5Item;

  created() {
    // debugger;
  }
  //模块展示
  Show(p: string) {
    return this.all.reportShowConfig?.[p] !== 1;
  }

  mounted() {
    // this.open();
  }
}
